'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('babel-runtime/helpers/defineProperty'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _slicedToArray = _interopDefault(require('babel-runtime/helpers/slicedToArray'));

/**
 * @class ShopifyMarketing.Helpers.Cookie
 */

var cookieHelper = {

  /**
   * Return the value for a cookie by the given `key`.
   *
   * @method get
   * @param {string} key Name of the cookie to get.
   * @param {string} cookies Defaults to `document.cookie`
   * @return {string|undefined}
   */
  get: function get(key) {
    var cookies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.cookie;

    var entries = cookies.split(/;\s*/).map(function (item) {
      return item.split('=').map(decodeURIComponent);
    }).reduce(function (obj, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          value = _ref2[1];

      return _Object$assign(obj, _defineProperty({}, name, value));
    }, {});

    return entries[key];
  },

  /**
   * Sets the value of the cookie `key`, given `value`.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
   * @method set
   * @param {string} key Name of the cookie to set
   * @param {string} value Value of the cookie to set (will passed `encodeURIComponent`)
   * @param {object} [options={}]
   * @param {string} [options.expires] Set the cookie expiry (in UTC string format)
   * @param {string} [options.path] Set the cookie path
   * @return {string}
   */
  set: function set(key, value) {
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        expires = _ref3.expires,
        path = _ref3.path;

    var string = encodeURIComponent(key) + '=' + encodeURIComponent(value);
    string += expires ? '; expires=' + expires : '';
    string += path ? '; path=' + path : '';
    string += '; secure';
    document.cookie = string;

    return string;
  }
};

module.exports = cookieHelper;
